function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#0F99D6;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#ED1C24;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Past-Due-List"
}, /*#__PURE__*/React.createElement("g", {
  id: "Past-Due-List-2",
  transform: "translate(-24.000000, -37.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "_x31_04x37_x5F_white-x-color",
  transform: "translate(24.000000, 37.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-12",
  transform: "translate(0.000000, -0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-4",
  transform: "translate(-0.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path",
  className: "st0",
  d: "M18.5,0.1c10,0,18.1,8.2,18.1,18.4s-8.1,18.4-18.1,18.4c-1.3,0-2.9-0.3-4.9-0.9 c-1.5-0.4-2.4-2-1.9-3.5c0-0.2,0.1-0.3,0.2-0.5c0.8-1.6,2.6-2.4,4.3-2c0.9,0.2,1.7,0.3,2.4,0.3c6.5,0,11.7-5.3,11.7-11.9 S25,6.6,18.5,6.6S6.8,11.9,6.8,18.5c0,0.7,0.1,1.5,0.3,2.5c0.4,1.7-0.4,3.5-2,4.3c-1.4,0.7-3,0.1-3.7-1.2 c-0.1-0.2-0.1-0.3-0.2-0.5c-0.6-2-0.9-3.7-0.9-5C0.4,8.3,8.5,0.1,18.5,0.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Combined-Shape",
  className: "st0",
  d: "M18.5,0.2c4.9,0,9.4,2,12.6,5.2L26.8,10c-2.1-2.1-5-3.4-8.3-3.4 C12,6.6,6.8,11.9,6.8,18.5c0,0.7,0.1,1.5,0.3,2.4c0.4,1.7-0.4,3.5-2,4.3c-1.4,0.7-3,0.1-3.7-1.2c-0.1-0.2-0.1-0.3-0.2-0.5 c-0.6-2-0.9-3.7-0.9-5C0.4,8.4,8.5,0.2,18.5,0.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Combined-Shape_1_",
  className: "st1",
  d: "M18.5,0c10,0,18.1,8.2,18.1,18.4c0,9-6.4,16.6-14.9,18.1c5.8-2.4,9.9-8.2,9.9-15 c0-9-7.2-16.2-16-16.2c-7,0-13,4.6-15.2,11C1.5,7.2,9.2,0,18.5,0z"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval",
  className: "st2",
  cx: 18.5,
  cy: 18.3,
  rx: 7.9,
  ry: 8
}))))));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 37 37",
    style: {
      enableBackground: "new 0 0 37 37"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Logo.24210cf0.svg";
export { ForwardRef as ReactComponent };